import { render, staticRenderFns } from "./global-solution.layout.vue?vue&type=template&id=2b380488"
import script from "./global-solution.layout.ts?vue&type=script&lang=ts&external"
export * from "./global-solution.layout.ts?vue&type=script&lang=ts&external"
import style0 from "./global-solution.layout.vue?vue&type=style&index=0&id=2b380488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports